<div *ngIf="enableSearch" class="filter-textbox">
  <input
    type="text"
    (keyup)="filterDefects()"
    [(ngModel)]="filterString"
    placeholder="{{ 'input_app_multi_select.inputPlaceholder' | translate }}"
  />
  <i class="zf-icon zf-icon-search zf-icon-s"></i>
</div>

<ion-row class="m-multi-select">
  <ion-col sizeLg="4" sizeMd="6" size="12" class="ion-no-padding" *ngFor="let item of filteredList; trackBy: trackByFn">
    <ion-card
      (click)="onSelect(item.id)"
      class="m-multi-select__item"
      [ngClass]="{ 'm-multi-select__item--selected': item.selected }"
      style="max-height: 100px"
    >
      <ion-card-header>
        <ion-card-title
          class="card-title"
          [ngClass]="{ 'card-title--selected': item.selected && !item.issue_name.length }"
        >
          <div class="card-title__container">
            <div class="card-title__label">
              <span *ngIf="showCategoryId" class="card-title__category_id">{{ item.category_id }}</span
              >{{ item.name }}
            </div>
            <div class="card-title__issue-name">
              {{ item.issue_name }}
            </div>
          </div>
          <div *ngIf="item.department" class="card-title__dept-name">
            {{ item.department | titlecase }}
          </div>
        </ion-card-title>
      </ion-card-header>
    </ion-card>
  </ion-col>
</ion-row>
<div *ngIf="!filteredList.length" class="m-multi-select__default-error">
  {{ 'input_app_multi_select.noItemsAvailable' | translate }}
</div>
